import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Button from "components/ui/controls/button/button";
import { FaCalculator, FaSync } from "react-icons/fa";
import { createStyledButton } from "components/ui/controls/button/button-styles";

const TauxRemplacement = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>            <Row tpad>
              <div style={{
                backgroundColor: "white",
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                padding: "16px",
                width: "100%",
                minHeight: "96px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                marginBottom: "12px"
              }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      backgroundColor: "#dbeafe",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <FaCalculator style={{ fontSize: "14px", color: "#3b82f6" }} />
                    </div>
                    <div>
                      <div style={{ fontSize: "12px", fontWeight: "600", color: "#1f2937", marginBottom: "2px" }}>
                        Revenus nets de l'année en cours
                      </div>
                      <div style={{ fontSize: "12px", color: "#6b7280" }}>
                        {!context.state["CarriereSalaireReferenceSaisi" + ClientConjoint] ? "Calculé automatiquement" : "Saisi manuellement"}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Button 
                      tabIndex="-1" 
                      icon 
                      onClick={() => context.handleCarriereSalaireReferenceSaisi("CarriereSalaireReferenceSaisi" + ClientConjoint, ClientConjoint, "")}
                      {...createStyledButton("card-action", "cardEdit",{backgroundColor:"#dbeafe"})}
                    >
                      {!context.state["CarriereSalaireReferenceSaisi" + ClientConjoint] ? 
                        <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} /> : 
                        <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                      }
                    </Button>
                    <TextField
                      value={context.state["CarriereSalaireReference" + ClientConjoint]}
                      onBlur={(e) => {
                        context.handleCarriereSalaireReferenceSaisi("CarriereSalaireReferenceSaisi" + ClientConjoint, ClientConjoint, e.target.value);
                      }}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      small
                      style={{ minWidth: "120px" }}
                    />
                  </div>
                </div>
              </div>
            </Row>
          </Column>
        </CardBox>
      </Column>
    </>
  );
};
export default TauxRemplacement;
